import script from "./TokenSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./TokenSelect.vue?vue&type=script&setup=true&lang=ts"

import "./TokenSelect.vue?vue&type=style&index=0&id=8ce96f00&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ce96f00"]])

export default __exports__